// global googleTranslateElementInit2 google
import { loadScript, useReady } from '../utils/dom';
import { trackLanguageChange } from '../tracking';

const TRANSLATE_URL =
  '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2';

const init = async (translateSelects) => {
  // console.log('lang', GTranslateGetCurrentLang());

  // Check for language in url
  const urlParams = new URLSearchParams(window.location.search);
  let langParam = urlParams.get('lang');
  if (langParam) {
    await loadTranslate();
    const lang = `en|${langParam}`;
    doGTranslate(lang);
    handleChatbotVisibility(lang);
  }

  // Check for current language
  if (!langParam) {
    langParam = GTranslateGetCurrentLang();
  }

  if (langParam) {
    await loadTranslate();

    // Set selects to current language
    translateSelects.forEach((el) => {
      const option = el.querySelector(`[value="en|${langParam}"]`);
      if (!option) return;

      option.setAttribute('selected', true);
    });
  }

  translateSelects.forEach((el) => {
    el.addEventListener('change', async (event) => {
      const lang = event.target.value;
      if (!lang) return;

      await loadTranslate();
      doGTranslate(lang);
      handleChatbotVisibility(lang);

      // Get the full language name from the LANGUAGE_MAP
      const langCode = lang.split('|')[1];
      const fullLangName = LANGUAGE_MAP[langCode];

      // Call trackLanguageChange with the full language name
      trackLanguageChange(fullLangName);
    });
  });
};

// Run a translation
const doGTranslate = (lang_pair) => {
  if (lang_pair.value) lang_pair = lang_pair.value;
  if (lang_pair == '') return;
  var lang = lang_pair.split('|')[1];
  if (GTranslateGetCurrentLang() == null && lang == lang_pair.split('|')[0]) return;
  var teCombo;
  var sel = document.getElementsByTagName('select');
  for (var i = 0; i < sel.length; i++)
    if (sel[i].className.indexOf('goog-te-combo') != -1) {
      teCombo = sel[i];
      break;
    }
  if (
    document.getElementById('google_translate_element2') == null ||
    document.getElementById('google_translate_element2').innerHTML.length == 0 ||
    teCombo.length == 0 ||
    teCombo.innerHTML.length == 0
  ) {
    setTimeout(() => {
      doGTranslate(lang_pair);
    }, 500);
  } else {
    teCombo.value = lang;
    GTranslateFireEvent(teCombo, 'change');
    GTranslateFireEvent(teCombo, 'change');
  }
};

// Ensure translate is loaded only once
let translatePromise = null;
const loadTranslate = () => {
  if (translatePromise) {
    // console.log('return promise');
    return translatePromise;
  }

  // console.log('load translate');
  translatePromise = new Promise((resolve, reject) => {
    loadScript(TRANSLATE_URL);

    const googleTranslateElementInit2 = () => {
      new google.translate.TranslateElement(
        { pageLanguage: 'en', autoDisplay: false },
        'google_translate_element2'
      );
      const translateEl = document.querySelector('#google_translate_element2');
      if (translateEl) {
        translateEl.querySelector('a').outerHTML = '';
      }

      resolve();
    };

    window.googleTranslateElementInit2 = googleTranslateElementInit2;
  });

  return translatePromise;
};

// Get currently set language
const GTranslateGetCurrentLang = () => {
  var keyValue = document['cookie'].match('(^|;) ?googtrans=([^;]*)(;|$)');
  return keyValue ? keyValue[2].split('/')[2] : null;
};

// Event helper
const GTranslateFireEvent = (element, event) => {
  try {
    if (document.createEventObject) {
      var evt = document.createEventObject();
      element.fireEvent('on' + event, evt);
    } else {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent(event, true, true);
      element.dispatchEvent(evt);
    }
  } catch (e) {}
};

// Use translation code
const LANGUAGE_MAP = {
  en: 'English',
  es: 'Spanish',
  ja: 'Japanese',
  vi: 'Vietnamese',
  'zh-CN': 'Chinese',
  tl: 'Tagalog',
  fa: 'Farsi',
  ru: 'Russian',
  'zh-HK': 'Cantonese',
};
export const useTranslation = (form) => {
  const setLanguageInput = () => {
    let langInput = form.querySelector('[name="language"]');
    if (!langInput) {
      langInput = document.createElement('input');
      langInput.setAttribute('type', 'hidden');
      langInput.setAttribute('name', 'language');
      form.appendChild(langInput);
    }

    const langCode = GTranslateGetCurrentLang() || 'en';
    const lang = LANGUAGE_MAP[langCode] || 'Other';
    langInput.value = lang;
  };

  return {
    getLanguage: GTranslateGetCurrentLang,
    setLanguageInput,
  };
};

const handleChatbotVisibility = (langPair) => {
  // Show chatbot for English
  if (langPair === 'en|en') {
    document.body.classList.remove('chatbot-hide');
    return;
  }

  // Hide chatbot for other languages
  document.body.classList.add('chatbot-hide');
};

// Init on page load
useReady(() => {
  const translateSelects = document.querySelectorAll('[data-plugin="translate"]');

  if (translateSelects && translateSelects.length > 0) {
    init(translateSelects);
  }
});
